class AnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.emblaNode = this.querySelector('.embla');
    this.closeButton = this.querySelector('.tw-close button');
    this.init;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    if (!this.emblaNode) return;

    const options = {
      loop: true,
    };

    const autoScrollOptions = {
      playOnInit: true,
      stopOnInteraction: false,
      stopOnMouseEnter: true,
      delay: 0,
      speed: 0.26,
    };

    // Initialize Embla with the AutoScroll plugin

    const emblaApi = EmblaCarousel(this.emblaNode, options, [EmblaCarouselAutoScroll(autoScrollOptions)]);

    // Handle close button
    if (this.closeButton) {
      this.closeButton.addEventListener('click', () => {
        this.remove();
      });
    }
  }
}

customElements.define('announcement-bar', AnnouncementBar);
